import { Category } from 'shared/models/target-groups/category';
import { Group } from 'shared/models/target-groups/group';
import {Company} from '../models/target-groups/company';

export class EventRegistrationCode {
  public _id: string;
  public code: string;
  public company: Company;
  public categories?: Array<Category>;
  public groups?: Array<Group>;
  public valid: boolean;

  constructor() {
    this.valid = true;
    this.company = {
      name: '',
    };
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/classes/event-registration-code.ts